<template>
    <div class="p-6">
        <div class="flex w-full justify-center text-ihh-midnight-gray text-2xl font-semibold font-serif">Terms and Conditions</div>
        <TermsModal class="p-6" />
    </div>
</template>

<script>
import TermsModal from './ihh-items/terms-modal.vue'
export default {
    components: { TermsModal },
    data() {
        return {

        }
    }
}
</script>
